import { Box, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React from "react";
import columnsBuilder from "./columnsBuilder";
import { generateUUID, getToDay, slice } from "../../Common/Utility";
import { useEffect, useState, useRef } from "react";
import { Get } from "../../Common/WebRequest";
import { blue } from "@mui/material/colors";
import { useLocation } from "react-router-dom";
import EditToolbar from "./EditToolbar";

const SystemLogs = (props) => {
  const [logData, setLogData] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dateFrom = useRef();
  const dateTo = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const filter = searchParams.get("state");

  useEffect(() => {
    (async () => {
      await loadLogData();
      if (filter !== "") {
        console.log("Filter =>> " + filter);
      }
    })();
  }, [filter]);

  async function loadLogData() {
    setError("");
    setLogData([]);
    setIsLoading(true);

    try {
      const res = await Get(
        "SystemLog/" + dateFrom.current.value + "/" + dateTo.current.value
      );

      if (res.isSuccess) {
        setLogData(res.result);
      } else {
        if (res.result && !res.result.includes("200/No Results"))
          setError(res.Status + "/" + res.Error + "/" + res.ErrorDetail);
      }
    } catch (error) {
      setError("Failed to load system logs: " + error.message);
    } finally {
      setIsLoading(false);
    }
  }
  async function handleShow(e) {
    e.preventDefault();
    await loadLogData();
    console.log(dateFrom.current.value, dateTo.current.value);
  }
  return (
    <>
      {error.length > 0 && (
        <div className="alert alert-danger" role="alert">
          {slice(error, 100, "...")}
        </div>
      )}
      <div className="App" style={{ backgroundColor: "white" }}>
        <Typography
          variant="headline"
          component="h2"
          align="left"
          color={blue[500]}
        >
          System Logs
        </Typography>
      </div>
      <br />
      <form className="d-flex gap-3 align-items-center mb-3">
        <div className="d-flex align-items-center">
          <label htmlFor="from" className="me-2">
            Von
          </label>
          <input
            className="form-control"
            id="from"
            type="date"
            ref={dateFrom}
            defaultValue={getToDay()}
          />
        </div>

        <div className="d-flex align-items-center">
          <label htmlFor="to" className="me-2">
            Zum
          </label>
          <input
            className="form-control"
            id="to"
            type="date"
            ref={dateTo}
            defaultValue={getToDay()}
          />
        </div>

        <button className="btn btn-primary" onClick={handleShow}>
          Vorschu
        </button>
      </form>
      <br />
      <Box sx={{ width: "1", height: "800px" }}>
        <DataGrid
          loading={isLoading}
          density="compact"
          rowSelection={false}
          rows={logData}
          columns={columnsBuilder()}
          getRowId={(row) => generateUUID()}
          slots={{ toolbar: EditToolbar }}
          components={{ Toolbar: GridToolbar }}
          rowsPerPageOptions={100}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100, page: 0 },
            },
            filter: {
              filterModel: {
                items: [{ field: "message", operator: "contains", value: "" }],
                quickFilterValues: [filter],
              },
            },
          }}
        />
      </Box>
    </>
  );
};

export default SystemLogs;
